import React from "react";
import "./LegalNotice.scss";

export default function LegalNotice() {
  return (
    <main id="main-content" className="legal-notice" tabIndex="-1">
      <a className="legal-notice__back" href="#/">
        ← Retour à l’accueil
      </a>

      <article>
        <h1>Mentions légales</h1>
        <p className="legal-notice__updated">
          Dernière mise à jour : 2 août 2026
        </p>

        <section>
          <h2>Éditeur du site</h2>
          <p>
            Le site <strong>simon.wf</strong> est édité par KV2,
            micro-entreprise représentée par Stéphane Simon.
          </p>
          <p>
            Adresse : 17 rue des Petits Bus, 60590 Flavacourt, France
            <br />
            SIRET : 530 476 183 00013
            <br />
            Contact :{" "}
            <a
              href="https://kv2.fr/contact-postmaster/"
              target="_blank"
              rel="noopener noreferrer"
            >
              formulaire de contact KV2
            </a>
          </p>
        </section>

        <section>
          <h2>Hébergement</h2>
          <p>
            Le site est hébergé et administré par KV2 Webmaster sur des serveurs
            bare metal dédiés. Les centres de données sont situés à Düsseldorf,
            en Allemagne, et à Gravelines, en France.
          </p>
        </section>

        <section>
          <h2>Responsabilité éditoriale</h2>
          <p>
            Le responsable de la publication est Stéphane Simon, en sa qualité
            de webmaster freelance.
          </p>
        </section>

        <section>
          <h2>Propriété intellectuelle</h2>
          <p>
            Sauf mention contraire, les textes, images, créations et autres
            contenus présents sur ce site sont protégés par le droit de la
            propriété intellectuelle. Toute reproduction, représentation ou
            adaptation, totale ou partielle, nécessite l’autorisation préalable
            de leur titulaire.
          </p>
        </section>

        <section>
          <h2>Responsabilité</h2>
          <p>
            Les informations publiées sont fournies à titre indicatif et peuvent
            être modifiées à tout moment. L’éditeur s’efforce de les maintenir à
            jour, sans pouvoir garantir leur exhaustivité. Il ne saurait être
            tenu responsable du contenu des sites externes accessibles par des
            liens hypertextes.
          </p>
        </section>

        <section>
          <h2>Données personnelles et cookies</h2>
          <p>
            Pour toute question relative à vos données personnelles ou pour
            exercer vos droits d’accès, de rectification, d’effacement, de
            limitation ou d’opposition, vous pouvez écrire à{" "}
            <a
              href="https://kv2.fr/contact-postmaster/"
              target="_blank"
              rel="noopener noreferrer"
            >
              notre formulaire de contact
            </a>
            .
          </p>
          <p>
            Le site peut utiliser des outils de mesure d’audience uniquement
            après votre consentement. Vous pouvez modifier votre choix en
            supprimant les préférences du site dans votre navigateur.
          </p>
        </section>
      </article>
    </main>
  );
}
